// extracted by mini-css-extract-plugin
export default {"content":"DetailsDialog_content__ya67S","caption":"DetailsDialog_caption__tCXGG"};